import React from 'react';
import { useAppDispatch } from '../../../../../app/redux/useAppSelector';
import { usePendingMagneticWallItem } from '../../../../../post/PendingMagneticWallItemProvider';
import { useVisibleMagneticWallItemIds } from '../../../../../post/useVisibleMagneticWallItems';
import { useQuill } from '../../../../QuillContext';
import { EditorActions } from '../../../../editorSlice';
import type { Blot } from '../../../../types';
import { commentIcon } from '../../../editorIcons';
import ToolbarButton from '../ToolbarButton';
import selectBlotAndWaitMagneticWallUpdate from './selectBlotAndWaitMagneticWallUpdate';

interface ToolbarCommentButtonProps {
  existingComment?: string[] | null;
  blot?: Blot;
  onClick?: () => void;
}

const ToolbarCommentButton = ({
  existingComment,
  blot,
  onClick,
}: ToolbarCommentButtonProps) => {
  const visibleItemIds = useVisibleMagneticWallItemIds();
  const dispatch = useAppDispatch();
  const { quill } = useQuill();
  const { createPendingCommentThread } = usePendingMagneticWallItem();

  const visibleCommentIds = existingComment
    ? existingComment.filter((id) => visibleItemIds.has(`comment-${id}`))
    : [];

  return (
    <ToolbarButton
      icon={commentIcon}
      tooltip="Comment"
      shortcut="Ctrl + Alt + m"
      active={visibleCommentIds.length > 0}
      onClick={async () => {
        onClick?.();

        const firstVisibleCommentId = visibleCommentIds[0];
        if (firstVisibleCommentId) {
          dispatch(
            EditorActions.focusMagneticWall({
              id: firstVisibleCommentId,
              type: 'comment',
              isActive: true,
              hasExpandIntent: false,
            }),
          );
          return;
        }

        if (blot) {
          await selectBlotAndWaitMagneticWallUpdate(blot);
        }
        if (!quill) return;
        quill.root.blur(); // blur so that the comment input can get focus

        createPendingCommentThread();
      }}
    />
  );
};

export default ToolbarCommentButton;
